export const getBaseDomain = (): string => {
  if (typeof window !== 'undefined' && window.location.hostname) {
    const parts = window.location.hostname.split('.');
    if (parts.length >= 2) {
      return parts.slice(-2).join('.');
    }
  }
  return 'demodbi360.com';
};

